import { css } from '@emotion/react'
import uEmojiParser from 'universal-emoji-parser'
import {
  DesignToken,
  SpacingToken,
  Text,
} from '@livechat/design-system-react-components'

import Stars from '..'

const reviewWrapperCss = css`
  padding: var(${SpacingToken.Spacing5}) 0;
  border-top: 1px solid var(${DesignToken.BorderBasicTertiary});
`

const usernameCss = css`
  display: flex;
  align-items: center;

  > p {
    margin: 0;
  }

  > div {
    margin-left: 5px;
  }
`

const reviewTextCss = css`
  white-space: pre-line;
  margin: 0;
`

interface Props {
  rate: number
  name: string
  text: string
}

const Review = ({ rate, name, text }: Props) => {
  if (!text || !name) {
    return null
  }

  const emojiParsedText = uEmojiParser.parseToUnicode(text)

  return (
    <div css={reviewWrapperCss}>
      <div css={usernameCss}>
        <Text bold size="lg">
          {name}
        </Text>
        <Stars rate={rate} hideSummary />
      </div>
      <Text css={reviewTextCss}>{emojiParsedText}</Text>
    </div>
  )
}

export default Review
